import { useContext } from 'react';

import { CDFICertificationContext } from '@/context';

export const useCDFIData = () => {
  return useContext(CDFICertificationContext);
};
